import React from 'react';
import { Link } from 'react-router-dom';
import bem from 'utils/bem';
import Text from 'components/Text';
import TeaserPhoto from 'components/TeaserPhoto';
import './index.sass';
import { Skeleton } from '@mui/material';

const { block, el } = bem('purchase-item');
const PurchaseItem = ({item}) => {
    const { quantity, url } = item;
    const { name, photoResized, photo } = item.item;
    const itemPhoto = photoResized ? photoResized : photo;
    return (
        <Link className={block()} to={url}>
            <div className={el('photo')}>
                <TeaserPhoto src={ itemPhoto } />
            </div>
            <div className={el('name-amount')}>
                <Text>{ name }</Text>
                { quantity && <Text>{ `, ${quantity} шт` }</Text> }
            </div>
        </Link>
    )
}

export const PurchaseItemSkeleton = () => {
    return (
        <div className={block()}>
            <div className={el('photo')}>
                <Skeleton variant={'rounded'} width={48} style={{paddingTop: '100%'}}/>
            </div>
            <div className={el('name-amount')}>
                <Text><Skeleton width={90} /></Text>
            </div>
        </div>
    )
}

export default PurchaseItem;
